export const ACCEPT_ALL = '*';
